import queryString from 'query-string';
import { currentBreakpoint } from "Helpers/BreakpointHelper";

export const Image = (_image) => {
  return _image.UmbracoFile ? _image.UmbracoFile : null;
};

export const GetBackgroundPositionCoordinates = (source) => {
    const subStr = new URL(window.location.href + source).search.substring(1);
		const parsed = queryString.parse(subStr);
		const { mode, center } = parsed;
		const y = mode !== undefined && center !== undefined ? center.split(',')[0] * 100 : -1;
    const x = mode !== undefined && center !== undefined ? center.split(',')[1] * 100 : -1;
    
    const coordinates = x !== -1 && {x: x, y: y, mode: mode};

    return coordinates;
}


export const GetResponsiveImage = (props) => {
    if (props != undefined && !Array.isArray(props)) {
        const { Desktop, Ipad, Mobile } = props;

        switch (currentBreakpoint()) {
            case "mobile":
                return Mobile;
            case "desktop":
                return Desktop;
            case "ipad":
                return Ipad;
            default:
                return Desktop;
        }
    } else {
        const size = currentBreakpoint();
        return props?.map((image) => {
            const { Desktop, Ipad, Mobile } = image;
            switch (size) {
                case "mobile":
                    return Mobile;
                case "desktop":
                    return Desktop;
                case "ipad":
                    return Ipad;
                default:
                    return Desktop;
            }
        });
    }
};